// import { useSearchParams } from '@bridebook/web/lib/search/hooks/query/use-search';
import { useRouter } from 'next/router';
// import { useMarket } from '@bridebook/web/app-shared/lib/i18n/hooks/use-market';

/**
 * The new Venue Profile V2 means a new design rollout around October 2025.
 * Right now all venue profiles on logged out should use this.
 */
export const useIsVenueProfileV2 = () => {
  const location = useRouter();
  // const searchParams = useSearchParams();
  // const market = useMarket();

  return (
    location.route === '/[market]/basic/supplier/[slug]/[id]' && location.query.slug === 'venues'
  );
  // LIVE-24199 - ** use commented code instead of return above to disable venueProfileV2 in core markets **
  // const isCoreMarket = (market || searchParams?.market)?.flags?.monetized;
  // const isVenueProfile =
  //   location.route === '/[market]/basic/supplier/[slug]/[id]' && location.query.slug === 'venues';
  // return isVenueProfile && !isCoreMarket;
};
